import _findKey from 'lodash/findKey';
import { getPresetSize } from '../containers/Packages/utils';
import { Parcel, ShipmentType } from '../types/common';
import countries from './countries.json';

interface Route {
  originCountry: string;
  destinationCountry: string;
}

export const slugToType: Record<string, ShipmentType> = {
  envelope: ShipmentType.DOCUMENT,
  'small-parcel': ShipmentType.PARCEL,
  'medium-parcel': ShipmentType.PARCEL,
  'large-parcel': ShipmentType.PARCEL,
};

export const slugToDocumentSize: Record<string, Parcel> = {
  envelope: getPresetSize('envelope', ShipmentType.DOCUMENT),
};

export const slugToParcelSize: Record<string, Parcel> = {
  'small-parcel': getPresetSize('small', ShipmentType.PARCEL),
  'medium-parcel': getPresetSize('medium', ShipmentType.PARCEL),
  'large-parcel': getPresetSize('large', ShipmentType.PARCEL),
};

export const parseRoute = (slug = ''): Route => {
  const [originSlug, destinationSlug] = slug.split('-to-');
  const originCountry = _findKey(countries, (country) => country === originSlug) || '';
  const destinationCountry = _findKey(countries, (country) => country === destinationSlug) || '';
  return { originCountry, destinationCountry };
};

export const getMatchedSlug = (parcels: Parcel[], type: ShipmentType): string => {
  if (parcels.length > 1) return 'parcels';
  const { length, width, height, weight } = parcels[0] || {};
  const sizes = type === ShipmentType.DOCUMENT ? slugToDocumentSize : slugToParcelSize;
  return _findKey(sizes, { length, width, height, weight }) || 'parcel';
};

export const getRoute = (originCountry: string, destinationCountry: string): string => {
  const originSlug = (countries as Record<string, string>)[originCountry];
  const destinationSlug = (countries as Record<string, string>)[destinationCountry];

  if (!originSlug || !destinationSlug) return '';
  return `${originSlug}-to-${destinationSlug}`;
};
